import constants from '~/utils/constants';

export type RoutesDrawerSortDirection =
    (typeof constants.sortOrder)[keyof typeof constants.sortOrder];

export interface RoutesDrawerMapModeSortSetting {
    /**
     * The routes drawer sort selected metric
     */
    sortMetric: string | null;

    /**
     * The routes drawer sort direction
     */
    sortDirection: RoutesDrawerSortDirection;
}

export interface RoutesDrawerSortState {
    /**
     * The routes drawer sort setting for `plan` map route mode
     */
    plan: RoutesDrawerMapModeSortSetting;

    /**
     * The routes drawer sort setting for `dispatched` map route mode
     */
    dispatched: RoutesDrawerMapModeSortSetting;

    /**
     * The routes drawer sort setting for `completed` map route mode
     */
    completed: RoutesDrawerMapModeSortSetting;
}

export type RoutesDrawerSortMapMode = keyof Pick<
    RoutesDrawerSortState,
    'plan' | 'dispatched' | 'completed'
>;

export interface RoutesDrawerMapModeSortMetricPayload {
    /**
     * The map route mode
     */
    mapMode: string;

    /**
     * the map route mode sort metric
     */
    sortMetric: string | null;
}

export interface RoutesDrawerMapModeSortDirectionPayload {
    /**
     * The map route mode
     */
    mapMode: string;

    /**
     * the map route mode sort direction
     */
    sortDirection: string;
}

export interface RoutesDrawerMapModeResetPayload {
    /**
     * The map route mode
     */
    mapMode: string;
}

export const defaultRoutesDrawerSortDirection = constants.sortOrder.DESC;

export const defaultRoutesDrawerMapModeSortMetric: RoutesDrawerMapModeSortSetting =
    {
        sortMetric: null,
        sortDirection: defaultRoutesDrawerSortDirection
    };

export const defaultRoutesDrawerSort: RoutesDrawerSortState = {
    plan: {
        sortMetric: constants.sortOptionKeys.STOP_COUNT,
        sortDirection: constants.sortOrder.DESC
    },
    dispatched: {
        sortMetric: constants.sortOptionKeys.STOP_COUNT,
        sortDirection: constants.sortOrder.DESC
    },
    completed: {
        sortMetric: constants.sortOptionKeys.STOP_COUNT,
        sortDirection: constants.sortOrder.DESC
    }
};
